import React from 'react';
/**
 * A Simply Youtube component
 *
 * @param	{string}	videoId	      id from Youtube
 * @param	{string}	width		      Video width. Default is 100%
 * @param	{string}	height		    Video height. Default is 400px
 *
 **/

var Youtube = function Youtube(_ref) {
  var _ref$videoId = _ref.videoId,
      videoId = _ref$videoId === void 0 ? '' : _ref$videoId,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '400px' : _ref$height,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'video' : _ref$title;
  return React.createElement("iframe", {
    title: title,
    width: width,
    height: height,
    src: "https://www.youtube.com/embed/".concat(videoId),
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  });
};

export default React.memo(Youtube);